import requestModel from "services/config/apiHandlers";

class Transactions {
  constructor(requestObj) {
    this.requestObj = requestObj;
    this.url = "api/transactions/";
    this.adminUrl = "api/admin/transaction/";
    this.downloadUrl = "download/";
  }

  async postTransactions() {
    const apiObj = {
      url: this.url + "charge",
      method: "post",
      reqObj: this.requestObj,
    };

    return await requestModel.response(apiObj);
  }

  async postTransactionsGiftCode(code) {
    const apiObj = {
      url: `${this.url}gift/${code}`,
      method: "post",
    };
    return await requestModel.response(apiObj);
  }

  async getTransactions(params) {
    const apiObj = {
      url: this.url,
      params,
    };

    return await requestModel.response(apiObj);
  }

  async getDepositedReport(params) {
    const apiObj = {
      url: this.adminUrl + 'report',
      params,
    };

    return await requestModel.response(apiObj);
  }

  async getDownloadFile(id) {
    const apiObj = {
      url: this.downloadUrl + id,
    };

    return await requestModel.response(apiObj);
  }
}

export default Transactions;
